import { Timestamp } from '@firebase/firestore-types';
import { AnyAction, Dispatch } from 'redux';
import { firestore } from '../../firebase';
import modelList from '../data/modelList';

interface ISiteRoute {
  alwaysShow: boolean;
  enabled: boolean;
}
// Not making things optional because they won't be in the final revision
interface ISiteRoutes {
  language: ISiteRoute;
  name: ISiteRoute;
  signature: ISiteRoute & { waiverText: string };
}

export const copySiteDataToSiblings = async () => {
  const sitesRef = firestore.collection(
    `businesses/TuNj9xLoEpFEpus1Od68/sites`,
  );

  try {
    const primaryQuery = await sitesRef.doc('3X9eSU2EUxS7EzB5ydSV').get();
    const sitesQuery = await sitesRef.get();

    const primaryData = primaryQuery.data();

    if (primaryData) {
      const primaryRoutes = primaryData.routes as ISiteRoutes;
      const sitePromises: Array<Promise<void>> = [];

      sitesQuery.forEach(siteDoc =>
        sitePromises.push(
          siteDoc.ref.set({ routes: primaryRoutes }, { merge: true }),
        ),
      );

      return Promise.all(sitePromises);
    }

    return;
  } catch (error) {
    console.error(error);

    return error;
  }
};

// copySiteDataToSiblings();

export const GET_MAKES = 'inventory.GET_MAKES';
export const getMakes = ({
  yearMax,
  yearMin,
}: {
  yearMax: string;
  yearMin: string;
}) => async (dispatch: Dispatch) => {
  const max = parseInt(yearMax, 10);
  const min = parseInt(yearMin, 10);

  const query = await firestore
    .collection('vehicles')
    .where('year', '<=', max)
    .where('year', '>=', min)
    .get();
  const makes: string[] = [];

  query.forEach(doc => {
    const makeData = doc.data();
    const { make } = makeData;

    if (make && makes.indexOf(make) === -1) {
      makes.push(make);
    }
  });

  dispatch({ payload: makes, type: GET_MAKES });
};

export const GET_MODELS = 'inventory.GET_MODELS';
export const getModels: GetModels = ({
  make,
  yearMax,
  yearMin,
  businessId,
  siteId
}: {
  make: string;
  yearMax: string;
  yearMin: string;
  businessId?: string | null | undefined;
  siteId?: string | null | undefined;
}) => async (dispatch: Dispatch) => {

  // smart matching start 
  let smartMatching = false;
  if(businessId && businessId !== '-' && siteId && siteId !== '-'){
    await firestore
      .collection("businesses")
      .doc(businessId)
      .collection("sites")
      .where("siteId", "==", siteId)
      .get()
      .then((siteSnap) => {
        if(siteSnap && siteSnap.docs[0]){
          const siteDoc = siteSnap.docs[0].data();
          smartMatching = siteDoc.smartMatching;
        }
      });
  }
  // smart matching end

  try {

    const query = await firestore
      .collection('vehicles')
      .where('year', '>=', Number(yearMin))
      .where('year', '<=', Number(yearMax))
      .where('make', '==', make)
      .get();
    const models: string[] = [];

    // console.log(query);
    query.forEach(doc => {
      const data = doc.data();
      // console.log('data: ' + data);
      const model = data.model as string;
      


      // smart matching start
      if (models.indexOf(model) === -1) {
        if( smartMatching ){
          const filtModel = modelList.filter((e) => e.make === make && e.model === model);
          if(filtModel[0]){
            if (models.indexOf(filtModel[0]['replaceby']) === -1){
              models.push(filtModel[0]['replaceby']);
            }
          }else{
            models.push(model);
          }
        }else{
          models.push(model);
        }

      }
      // smart matching End

      // const cSeriesTruck = [ "1", "2", "3", "5", "6", "7"];

      // const silverado = ["CHEVROLET 1500_PICKUP", "CHEVROLET 2500_PICKUP", "CHEVROLET 3500_PICKUP", "CHEVROLET HEAVY TRUCK", "CHEVROLET HEAVY_TRUCK"];

      // const van = [ "EXPRESS 1500",
      //               "EXPRESS 1500_VAN",
      //               "EXPRESS 2500",
      //               "EXPRESS 3500",
      //               "G10",
      //               "G10 VAN",
      //               "G20",
      //               "G20 VAN",
      //               "G30",
      //               "G30 VAN",
      //               "P10",
      //               "P10 SERIES",
      //               "P10 VAN",
      //               "P20",
      //               "P20 SERIES",
      //               "P20 VAN",
      //               "P30",
      //               "P30 SERIES",
      //               "P30 VAN",
      //               "CHEVROLET 10_VAN"
      //             ];

      // const kSeriesTruck = [
      //                         "K10",
      //                         "K10 PICKUP",
      //                         "K1500",
      //                         "K20",
      //                         "K20 PICKUP",
      //                         "K2500",
      //                         "K30",
      //                         "K30 PICKUP",
      //                         "K3500",
      //                         "K5 BLAZER"
      //                       ];

      // const rSeriesTruck = [
      //                       "R10",
      //                       "R20",
      //                       "R2500",
      //                       "R30",
      //                       "R3500"
      //                       ];                                

      // const sSeriesTruck = [
      //                       "S10",
      //                       "S10 BLAZER",
      //                       "S15",
      //                       "S15 JIMMY"
      //                       ];                                

      // const vSeriesTruck = [
      //                       "V10",
      //                       "V20",
      //                       "V30",
      //                       "V3500"
      //                       ];     

      // const suburban = [
      //                   "C10 SUBURBAN",
      //                   "C1500 SUBURBAN",
      //                   "C20 SUBURBAN",
      //                   "C2500 SUBURBAN",
      //                   "K10 SUBURBAN",
      //                   "K1500 SUBURBAN",
      //                   "K20 SUBURBAN",
      //                   "K2500 SUBURBAN",
      //                   "R10 SUBURBAN",
      //                   "R1500 SUBURBAN",
      //                   "R20 SUBURBAN",
      //                   "R2500 SUBURBAN",
      //                   "SUBURBAN 1500",
      //                   "SUBURBAN 2500",
      //                   "SUBURBAN 30",
      //                   "SUBURBAN 3500",
      //                   "V10 SUBURBAN",
      //                   "V1500 SUBURBAN",
      //                   "V20 SUBURBAN",
      //                   "V2500 SUBURBAN"
      //                   ];    
      
      // const avalanche = [
      //                     "AVALANCHE",
      //                     "AVALANCHE 1500",
      //                     "AVALANCHE 2500"
      //                   ];                  

      // const aveo = [
      //               "AVEO",
      //               "AVEO5"
      //               ];        
      
      // const corvair = [
      //                   "CHEVROLET CORVAIR_TRUCK",
      //                   "CORVAIR TRUCK"
      //                 ];              


      // const citation = [
      //                    "CITATION", 
      //                    "CITATION II" 
      //                   ];
      // const cruze = [
      //               "CRUZE",   
      //               "CRUZE LIMITED"   
      //              ];  
                   
      // const gt = [
      //               "GT AMERICA",   
      //               "GT STRADA_5300",
      //               "GT VELOCE"   
      //              ];  
                   
      // const impala = [
      //               "IMPALA",   
      //               "IMPALA LIMITED"
      //              ];  
                   
      // const lumimaVan = [
      //               "LUMINA APV",   
      //               "LUMINA VAN"
      //              ];  
                   
      // const luvPickup = [
      //               "LUV",
      //               "LUV PICKUP"
      //              ];  
                   
      // const spark = [
      //               "SPARK",   
      //               "SPARK EV"
      //              ];  
                   
      // const trailblazer = [
      //               "TRAILBLAZER",   
      //               "TRAILBLAZER EXT"
      //              ];  
                   
                   
      // const gmc1000Series = [
      //                         "GMC 1000_PICKUP",
      //                         "1000 SERIES",
      //                         "G1000 SERIES"
      //                       ];
      // const gmcCSeriesTruck = [
      //                         "C15",
      //                         "C15%C1500 PICKUP",
      //                         "C1500",
      //                         "C25",
      //                         "C25 PICKUP and C2500 PICKUP",
      //                         "C35",
      //                         "C35%C3500 PICKUP",
      //                         "C3500",
      //                         "C3500HD",
      //                         "C5000",
      //                         "C6000",
      //                         "C6500 TOPKICK",
      //                         "C7000",
      //                         "C25%C2500 PICKUP",
      //                         "C2500"
      //                       ];

      // const gmcSuburban = [
      //                       "C15 SUBURBAN",
      //                       "C15%C1500 SUBURBAN",
      //                       "C1500 SUBURBAN",
      //                       "C25 SUBURBAN",
      //                       "C2500 SUBURBAN",
      //                       "K15 SUBURBAN",
      //                       "K15%K1500 SUBURBAN",
      //                       "K1500 SUBURBAN",
      //                       "K25 SUBURBAN",
      //                       "K25%K2500 SUBURBAN",
      //                       "K2500 SUBURBAN",
      //                       "R1500 SUBURBAN",
      //                       "R2500 SUBURBAN",
      //                       "SUBURBAN",
      //                       "SUBURBAN 1500",
      //                       "SUBURBAN 2500",
      //                       "V1500 SUBURBAN",
      //                       "V2500 SUBURBAN",
      //                       "C25%C2500 SUBURBAN"
      //                     ];  
      
                          
      // const gmcVan = [
      //                   "G15",
      //                   "G15%G1500 VAN",
      //                   "G1500",
      //                   "G25",
      //                   "G25%G2500",
      //                   "G2500",
      //                   "G35",
      //                   "G35%G3500 VAN",
      //                   "G3500",
      //                   "GMC 1500_VAN",
      //                   "GMC 3500_VAN",
      //                   "GMC FORWARD_CONTROL",
      //                   "P15%P1500 VAN",
      //                   "P25%P2500 VAN",
      //                   "P35%P3500 VAN",
      //                   "P15",
      //                   "P1500",
      //                   "P25",
      //                   "P2500",
      //                   "P35",
      //                   "P3500",
      //                   "SAVANA 1500",
      //                   "SAVANA 1500_VAN",
      //                   "SAVANA 2500",
      //                   "SAVANA 3500",
      //                   "W4500 FORWARD",
      //                   "G25%G2500 VAN",
      //                   "GMC 2500_VAN"
      //                 ];                    

      // const gmckSeriesTruck = [
      //                           "K15",
      //                           "K15%K1500 PICKUP",
      //                           "K1500",
      //                           "K25",
      //                           "K25%K2500 PICKUP",
      //                           "K2500",
      //                           "K35",
      //                           "K35%K3500 PICKUP",
      //                           "K3500"
      //                         ];    
                              
                              
      // const gmcrSeriesTruck = [
      //                           "R1500",
      //                           "R2500",
      //                           "R3500"
      //                         ];
                              
      // const gmcsSeriesTruck = [
      //                           "S10",
      //                           "S10 BLAZER",
      //                           "S15",
      //                           "S15 JIMMY"
      //                         ];    
                              
      // const gmcSierra = [
      //                     "GMC 1500_PICKUP",
      //                     "GMC 3500_PICKUP",
      //                     "GMC HEAVY_TRUCK",
      //                     "SIERRA",
      //                     "SIERRA 1500",
      //                     "SIERRA 1500_CLASSIC",
      //                     "SIERRA 1500_HD",
      //                     "SIERRA 1500_HD_CLASSIC",
      //                     "SIERRA 2500",
      //                     "SIERRA 2500_HD",
      //                     "SIERRA 2500_HD_CLASSIC",
      //                     "SIERRA 3500",
      //                     "SIERRA 3500_CLASSIC",
      //                     "SIERRA 3500_HD",
      //                     "SIERRA 3500_PICKUP",
      //                     "SIERRA C3",
      //                     "SIERRA DENALI",
      //                     "SIERRA DENALI 2500",
      //                     "SIERRA DENALI 3500",
      //                     "SIERRA DENALI_1500",
      //                     "SIERRA DENALI_2500",
      //                     "SIERRA DENALI_3500"
      //                   ];

      // const gmcvSeriesTruck = [
      //                           "V1500",
      //                           "V2500",
      //                           "V3500"
      //                         ];               

      // const gmcYukon = [
      //                   "YUKON",
      //                   "YUKON XL",
      //                   "YUKON XL 1500",
      //                   "YUKON XL_1500",
      //                   "YUKON XL_2500"
      //                  ];
                      
      // const gmcEnvoy = [
      //                   "ENVOY",  
      //                   "ENVOY XL",  
      //                   "ENVOY XUV"
      //                   ];                 


      // const dodgeRamTruckSeries = [
      //                            "1500", 
      //                            "2500", 
      //                            "3500", 
      //                            "4500", 
      //                            "5500", 
      //                            "DODGE 3500¬_MEGA_CAB_PICKUP", 
      //                            "DODGE FORWARD_CONTROL", 
      //                            "DODGE HEAVY_DUTY_TRUCK", 
      //                            "DODGE PICKUP TRUCK", 
      //                            "DODGE PICKUP_TRUCK", 
      //                            "RAM 2500", 
      //                            "RAM 3500", 
      //                            "RAM 4500", 
      //                            "RAM 5500", 
      //                            "RAM PICKUP" 
      //                           ];                        
      
      
      // const dodge330 = [
      //                  "330", 
      //                  "330 GT" 
      //                 ];                          

      // const dodgeVan = [
      //                  "A100", 
      //                  "A108 VAN", 
      //                  "B100", 
      //                  "B100 VAN", 
      //                  "B150", 
      //                  "B1500", 
      //                  "B200", 
      //                  "B200 VAN", 
      //                  "B250", 
      //                  "B2500", 
      //                  "B300", 
      //                  "B300 VAN", 
      //                  "B350", 
      //                  "B3500", 
      //                  "C%V", 
      //                  "P100", 
      //                  "P200", 
      //                  "P300", 
      //                  "PROMASTER 1500", 
      //                  "PROMASTER 2500", 
      //                  "PROMASTER 3500", 
      //                  "PROMASTER CITY", 
      //                  "RAM 1500_VAN", 
      //                  "RAM 2500_VAN", 
      //                  "RAM 3500_VAN", 
      //                  "SPRINTER 2500", 
      //                  "SPRINTER 3500", 
      //                  "SPRINTER VAN_3500"
      //                 ];
                      
      // const dodgedSeriesPickup = [
      //                              "D100", 
      //                              "D100 PICKUP", 
      //                              "D100 SERIES", 
      //                              "D150", 
      //                              "D200", 
      //                              "D200 PICKUP", 
      //                              "D200 SERIES", 
      //                              "D250", 
      //                              "D300", 
      //                              "D300 PICKUP", 
      //                              "D300 SERIES", 
      //                              "D350", 
      //                              "D400", 
      //                              "D450", 
      //                              "DODGE 100_PICKUP", 
      //                              "DODGE 400_PICKUP", 
      //                              "DODGE 450_ PICKUP"
      //                             ];                

      // const dodgePromasterVanSeries = [
      //                                   "PROMASTER 1500",
      //                                   "PROMASTER 2500",
      //                                   "PROMASTER 3500",
      //                                   "PROMASTER CITY"
      //                                 ];                            

      // const dodgeRamCharger = [
      //                           "RAM CHARGER",
      //                           "RAMCHARGER"
      //                         ];                            

      // const dodgeSprinterVanSeries = [
      //                                 "SPRINTER 2500",
      //                                 "SPRINTER 3500",
      //                                 "SPRINTER VAN_3500"
      //                                ];                            

      // const dodgewSeriesPickup = [
      //                             "W100",  
      //                             "W100 PICKUP",  
      //                             "W100 SERIES",  
      //                             "W150",  
      //                             "W200",  
      //                             "W200 PICKUP",  
      //                             "W200 SERIES",  
      //                             "W250",  
      //                             "W300",  
      //                             "W300 PICKUP",  
      //                             "W300 SERIES",  
      //                             "W350"
      //                            ];

      // const ford300 = [
      //                   "300",
      //                   "CUSTOM 300"
      //                 ];                           

      // const fordBronco = [
      //                   "BRONCO",
      //                   "BRONCO II"
      //                 ];                           

      // const fordCustom = [
      //                   "CUSTOM",
      //                   "CUSTOM 300",
      //                   "CUSTOM 500"
      //                 ];                           

      // const fordVan = [
      //                   "E-150",
      //                   "E100 ECONOLINE",
      //                   "E100 ECONOLINE_CLUB_WAGON",
      //                   "E250 SUPER DUTY",
      //                   "E250 SUPER_DUTY",
      //                   "E300 ECONOLINE",
      //                   "E350",
      //                   "E350 CLUB_WAGON",
      //                   "E350 ECONOLINE",
      //                   "E350 ECONOLINE_CLUB_WAGON",
      //                   "E350 SUPER_DUTY",
      //                   "E450 ECONOLINE_SUPER_DUTY",
      //                   "E450 ECONOLINE_SUPER_DUTY_STRIPPED",
      //                   "E450 SUPER DUTY",
      //                   "E450 SUPER_DUTY ECONOLINE",
      //                   "ECONOLINE SUPER DUTY",
      //                   "ECONOLINE SUPER_DUTY",
      //                   "FORD E150_VAN",
      //                   "FORD E550SD_VAN",
      //                   "F53",
      //                   "F59",
      //                   "FORD VAN",
      //                   "P350",
      //                   "P400",
      //                   "P500",
      //                   "TRANSIT CONNECT",
      //                   "TRANSIT150",
      //                   "TRANSIT 250",
      //                   "TRANSIT350",
      //                   "TRANSIT350 HD"
      //                 ];                           

      // const fordExplorer = [
      //                         "EXPLORER",
      //                         "EXPLORER SPORT_TRAC"
      //                       ];

      // const fordSuperDuty = [
      //                         "F SUPER_DUTY",
      //                         "F250 SUPER DUTY",
      //                         "F250 SUPER_DUTY",
      //                         "F350 SUPER_DUTY",
      //                         "F450 SUPER_DUTY",
      //                         "F550 SUPER DUTY",
      //                         "F550 SUPER_DUTY",
      //                         "FORD HEAVY TRUCK",
      //                         "FORD HEAVY_TRUCK"
      //                       ];

      // const fordF100 = [
      //                     "F100" ,
      //                     "F100 PANEL_DELIVERY",
      //                     "F100 PICKUP"
      //                   ];

      // const fordF150 = [
      //                     "F-150" ,
      //                     "F150 HERITAGE",
      //                     "F SUPER_DUTY"
      //                   ];

      // const fordfSeriesTruck = [
      //                           "F250",
      //                           "F250 PICKUP",
      //                           "F250 SUPER DUTY",
      //                           "F250 SUPER_DUTY",
      //                           "F350",
      //                           "F350 PICKUP",
      //                           "F350 SUPER_DUTY",
      //                           "F450 SUPER_DUTY",
      //                           "F500",
      //                           "F550 SUPER DUTY",
      //                           "F550 SUPER_DUTY",
      //                           "FORD F450 PICKUP",
      //                           "FORD F450_PICKUP",
      //                           "FORD F650SD_PICKUP",
      //                           "FORD F750SD_PICKUP",
      //                           "FORD HEAVY TRUCK",
      //                           "FORD HEAVY_TRUCK"
      //                           ];


      // const fordFalcon = [
      //                 "FALCON", 
      //                 "FALCON SEDAN DELIVER", 
      //                 "FALCON SEDAN_DELIVER" 
      //               ];

      // const fordForwardControl = [
      //                               "FORD FORWARD CONTROL", 
      //                               "FORD FORWARD_CONTROL" 
      //                             ];

      // const fordGalaxie = [
      //                       "GALAXIE", 
      //                       "GALAXIE 500" 
      //                     ];

      // const fordLtd = [
      //                   "LTD", 
      //                   "LTD CROWN_VICTORIA", 
      //                   "LTD II" 
      //                 ];

      // const fordMustang = [
      //                   "MUSTANG", 
      //                   "MUSTANG II" 
      //                 ];

      // const americanMotorsHummer = [
      //                                 "H2", 
      //                                 "H3", 
      //                                 "H3T", 
      //                                 "HUMMER", 
      //                                 "HUMMER H1" 
      //                               ];


      // here





      // if (models.indexOf(model) === -1) {
      //   if(!smartMatching){
      //     models.push(model);
      //   }
      //   else if (make === "CHEVROLET" && suburban.includes(model)) {
      //     if(!models.includes("SUBURBAN")){
      //       models.push("SUBURBAN");
      //     }
      //   }else if(make === "CHEVROLET" && model.charAt(0) === 'C' && cSeriesTruck.includes(model.charAt(1))){
      //     if(!models.includes("C SERIES TRUCK")){
      //       models.push("C SERIES TRUCK");
      //     }
      //   }else if(make === "CHEVROLET" && silverado.includes(model)){
      //     if(!models.includes("SILVERADO")){
      //       models.push("SILVERADO");
      //     }
      //   }else if(make === "CHEVROLET" && van.includes(model)){
      //     if(!models.includes("VAN")){
      //       models.push("VAN");
      //     }
      //   }else if(make === "CHEVROLET" && kSeriesTruck.includes(model)){
      //     if(!models.includes("K SERIES TRUCK")){
      //       models.push("K SERIES TRUCK");
      //     }
      //   }else if(make === "CHEVROLET" && rSeriesTruck.includes(model)){
      //     if(!models.includes("R SERIES TRUCK")){
      //       models.push("R SERIES TRUCK");
      //     }
      //   }else if(make === "CHEVROLET" && sSeriesTruck.includes(model)){
      //     if(!models.includes("S SERIES TRUCK")){
      //       models.push("S SERIES TRUCK");
      //     }
      //   }else if(make === "CHEVROLET" && vSeriesTruck.includes(model)){
      //     if(!models.includes("V SERIES TRUCK")){
      //       models.push("V SERIES TRUCK");
      //     }
      //   }else if(make === "CHEVROLET" && avalanche.includes(model)){
      //     if(!models.includes("AVALANCHE")){
      //       models.push("AVALANCHE");
      //     }
      //   }else if(make === "CHEVROLET" && aveo.includes(model)){
      //     if(!models.includes("AVEO")){
      //       models.push("AVEO");
      //     }
      //   }else if(make === "CHEVROLET" && corvair.includes(model)){
      //     if(!models.includes("CORVAIR")){
      //       models.push("CORVAIR");
      //     }
      //   }else if(make === "CHEVROLET" && citation.includes(model)){
      //     if(!models.includes("CITATION")){
      //       models.push("CITATION");
      //     }

      //   }else if(make === "CHEVROLET" && cruze.includes(model)){
      //     if(!models.includes("CRUZE")){
      //       models.push("CRUZE");
      //     }
      //   }else if(make === "CHEVROLET" && gt.includes(model)){
      //     if(!models.includes("GT")){
      //       models.push("GT");
      //     }
      //   }else if(make === "CHEVROLET" && impala.includes(model)){
      //     if(!models.includes("IMPALA")){
      //       models.push("IMPALA");
      //     }
      //   }else if(make === "CHEVROLET" && lumimaVan.includes(model)){
      //     if(!models.includes("LUMINA VAN")){
      //       models.push("LUMINA VAN");
      //     }
      //   }else if(make === "CHEVROLET" && luvPickup.includes(model)){
      //     if(!models.includes("LUV PICKUP")){
      //       models.push("LUV PICKUP");
      //     }
      //   }else if(make === "CHEVROLET" && spark.includes(model)){
      //     if(!models.includes("SPARK")){
      //       models.push("SPARK");
      //     }
      //   }else if(make === "CHEVROLET" && trailblazer.includes(model)){
      //     if(!models.includes("TRAILBLAZER")){
      //       models.push("TRAILBLAZER");
      //     }
      //   }else if(make === "CHEVROLET" && model === "CHEVROLET MOTORHOME"){
      //     console.log("model");
      //   }else if(make === "GMC" && gmc1000Series.includes(model)){
      //     if(!models.includes("1000 SERIES")){
      //       models.push("1000 SERIES");
      //     }
      //   }
      //   else if(make === "GMC" && gmcCSeriesTruck.includes(model)){
      //     if(!models.includes("C SERIES TRUCK")){
      //       models.push("C SERIES TRUCK");
      //     }
      //   }
      //   else if(make === "GMC" && gmcSuburban.includes(model)){
      //     if(!models.includes("SUBURBAN")){
      //       models.push("SUBURBAN");
      //     }
      //   }
      //   else if(make === "GMC" && gmcVan.includes(model)){
      //     if(!models.includes("VAN")){
      //       models.push("VAN");
      //     }
      //   }
      //   else if(make === "GMC" && gmckSeriesTruck.includes(model)){
      //     if(!models.includes("K SERIES TRUCK")){
      //       models.push("K SERIES TRUCK");
      //     }
      //   }
      //   else if(make === "GMC" && gmcrSeriesTruck.includes(model)){
      //     if(!models.includes("R SERIES TRUCK")){
      //       models.push("R SERIES TRUCK");
      //     }
      //   }
      //   else if(make === "GMC" && gmcsSeriesTruck.includes(model)){
      //     if(!models.includes("S SERIES TRUCK")){
      //       models.push("S SERIES TRUCK");
      //     }
      //   }
      //   else if(make === "GMC" && gmcSierra.includes(model)){
      //     if(!models.includes("SIERRA")){
      //       models.push("SIERRA");
      //     }
      //   }
      //   else if(make === "GMC" && gmcvSeriesTruck.includes(model)){
      //     if(!models.includes("V SERIES TRUCK")){
      //       models.push("V SERIES TRUCK");
      //     }
      //   }
      //   else if(make === "GMC" && gmcYukon.includes(model)){
      //     if(!models.includes("YUKON")){
      //       models.push("YUKON");
      //     }
      //   }
      //   else if(make === "GMC" && gmcEnvoy.includes(model)){
      //     if(!models.includes("ENVOY")){
      //       models.push("ENVOY");
      //     }
      //   }
      //   else if(make === "DODGE" && dodgeRamTruckSeries.includes(model)){
      //     if(!models.includes("RAM TRUCK SERIES")){
      //       models.push("RAM TRUCK SERIES");
      //     }
      //   }
      //   else if(make === "DODGE" && dodge330.includes(model)){
      //     if(!models.includes("330")){
      //       models.push("330");
      //     }
      //   }
      //   else if(make === "DODGE" && dodgeVan.includes(model)){
      //     if(!models.includes("VAN")){
      //       models.push("VAN");
      //     }
      //   }
      //   else if(make === "DODGE" && dodgedSeriesPickup.includes(model)){
      //     if(!models.includes("D SERIES PICKUP")){
      //       models.push("D SERIES PICKUP");
      //     }
      //   }
      //   else if(make === "DODGE" && dodgePromasterVanSeries.includes(model)){
      //     if(!models.includes("PROMASTER VAN SERIES")){
      //       models.push("PROMASTER VAN SERIES");
      //     }
      //   }
      //   else if(make === "DODGE" && dodgeRamCharger.includes(model)){
      //     if(!models.includes("RAMCHARGER")){
      //       models.push("RAMCHARGER");
      //     }
      //   }
      //   else if(make === "DODGE" && dodgeSprinterVanSeries.includes(model)){
      //     if(!models.includes("SPRINTER VAN SERIES")){
      //       models.push("SPRINTER VAN SERIES");
      //     }
      //   }
      //   else if(make === "DODGE" && dodgewSeriesPickup.includes(model)){
      //     if(!models.includes("W SERIES PICKUP")){
      //       models.push("W SERIES PICKUP");
      //     }
      //   }
      //   else if(make === "DODGE" && model === "DODGE MOTORHOME"){
      //     console.log(model);  
      //   }
      //   else if(make === "FORD" && ford300.includes(model)){
      //     if(!models.includes("300")){
      //       models.push("300");
      //     }
      //   }
      //   else if(make === "FORD" && fordBronco.includes(model)){
      //     if(!models.includes("BRONCO")){
      //       models.push("BRONCO");
      //     }
      //   }
      //   else if(make === "FORD" && fordCustom.includes(model)){
      //     if(!models.includes("CUSTOM")){
      //       models.push("CUSTOM");
      //     }
      //   }
      //   else if(make === "FORD" && fordVan.includes(model)){
      //     if(!models.includes("FORD VAN")){
      //       models.push("FORD VAN");
      //     }
      //   }
      //   else if(make === "FORD" && fordExplorer.includes(model)){
      //     if(!models.includes("EXPLORER")){
      //       models.push("EXPLORER");
      //     }
      //   }
      //   else if(make === "FORD" && fordSuperDuty.includes(model)){
      //     if(!models.includes("SUPER DUTY")){
      //       models.push("SUPER DUTY");
      //     }
      //   }
      //   else if(make === "FORD" && fordF100.includes(model)){
      //     if(!models.includes("F100")){
      //       models.push("F100");
      //     }
      //   }
      //   else if(make === "FORD" && fordF150.includes(model)){
      //     if(!models.includes("F-150")){
      //       models.push("F-150");
      //     }
      //   }
      //   else if(make === "FORD" && fordfSeriesTruck.includes(model)){
      //     if(!models.includes("F SERIES TRUCK (F250+)")){
      //       models.push("F SERIES TRUCK (F250+)");
      //     }
      //   }
      //   else if(make === "FORD" && fordFalcon.includes(model)){
      //     if(!models.includes("FALCON")){
      //       models.push("FALCON");
      //     }
      //   }
      //   else if(make === "FORD" && fordForwardControl.includes(model)){
      //     if(!models.includes("FORD FORWARD CONTROL")){
      //       models.push("FORD FORWARD CONTROL");
      //     }
      //   }
      //   else if(make === "FORD" && fordGalaxie.includes(model)){
      //     if(!models.includes("GALAXIE")){
      //       models.push("GALAXIE");
      //     }
      //   }
      //   else if(make === "FORD" && fordLtd.includes(model)){
      //     if(!models.includes("LTD")){
      //       models.push("LTD");
      //     }
      //   }
      //   else if(make === "FORD" && fordMustang.includes(model)){
      //     if(!models.includes("MUSTANG")){
      //       models.push("MUSTANG");
      //     }
      //   }
      //   else if(make === "FORD" && model === "FORD MOTORHOME"){
      //     console.log(model);  
      //   }
      //   else if(make === "AMERICAN MOTORS" && americanMotorsHummer.includes(model)){
      //     if(!models.includes("HUMMER")){
      //       models.push("HUMMER");
      //     }
      //   }
      //   // here
      //   else{
      //     models.push(model);
      //   }
      // }

    });

    console.log(models);

    dispatch({ payload: models, type: GET_MODELS });
  } catch (error) {
    console.error(error);
  }
};



export const GET_VEHICLES = 'inventory.GET_VEHICLES';
export const getVehicles: GetVehicles = (
  businessId: string,
  siteId: string,
) => async (dispatch: Dispatch) => {
  try {
    const inventorySnapshot = await firestore
      .collection(`businesses/${businessId}/sites/${siteId}/inventory`)
      .get();
    const vehicles: IVehicle[] = [];

    inventorySnapshot.forEach(doc => {
      const vehicle = doc.data() as IVehicle;

      vehicle.score = 0;

      vehicles.push(vehicle);
    });

    dispatch({ payload: vehicles, type: GET_VEHICLES });
  } catch (error) {
    console.error(error);
  }
};

/* action types */
export type GetMakes = (
  {
    yearMax,
    yearMin,
  }: {
    yearMax: string;
    yearMin: string;
  },
) => (dispatch: Dispatch<AnyAction>) => Promise<void>;

export type GetModels = (
  {
    make,
    yearMax,
    yearMin,
    businessId,
    siteId
  }: {
    make: string;
    yearMax: string;
    yearMin: string;
    businessId?: string | null | undefined;
    siteId?: string | null | undefined;
  },
) => (dispatch: Dispatch<AnyAction>) => Promise<void>;

export type GetVehicles = (
  businessId: string,
  siteId: string,
) => (dispatch: Dispatch<AnyAction>) => Promise<void>;

/* data types */
export interface IVehicle {
  arrivalDate: Timestamp;
  businessName: string;
  city: string;
  color: string;
  dbEntryDate: Timestamp;
  make: string;
  model: string;
  location: string;
  score: number;
  state: string;
  stockNumber: string;
  updatedDate: Timestamp;
  vin: string;
  year: number;
}



// WEBPACK FOOTER //
// ./src/store/actions/inventoryActions.ts